module.exports = __webpack_public_path__ + "img/sleeve binding length.8595af43.png";